import { TrackingInfo, Button, Span } from "@bridgesplit/ui";
import { COPY } from "app/constants";

export function WalletButton({
    onClick,
    disabled,
    trackingEvent
}: {
    onClick: () => void;
    disabled?: boolean;
    trackingEvent: TrackingInfo;
}) {
    return (
        <Button
            tracking={trackingEvent}
            key={"wallet-connect-id"}
            variant="outlined"
            textProps={{ sx: { gap: 1.5 } }}
            sx={{ justifyContent: "flex-start" }}
            onClick={onClick}
            disabled={disabled}
        >
            <Span> {COPY.CONNECT_PROMPT} </Span>
        </Button>
    );
}
